"use client";

import React from "react";
import { useParams } from "next/navigation";
import Section from "@/components/ui/Section";
import Wrapper from "@/components/ui/Wrapper";
import { Button } from "@/components/ui/Button";
import { useLayoutData } from "@/components/layout/LayoutDataProvider";

type GlobalText = {
  not_found?: {
    title_404?: string;
    subtitle_404?: string;
    home_link_text_404?: string;
  };
};

export default function NotFoundClient() {
  const params = useParams<{ lang?: string }>();
  const lang = params?.lang ?? "pt";

  const { global_text } = useLayoutData() as { global_text?: GlobalText };

  const title = global_text?.not_found?.title_404 ?? "404";
  const subtitle = global_text?.not_found?.subtitle_404 ?? "Page not found";
  const homeLabel =
    global_text?.not_found?.home_link_text_404 ?? "Back to home";

  return (
    <Section className="py-xl-to-xxl m-0 pb-0">
      <Wrapper className="flex justify-center">
        <div className="relative w-full p-20-to-44">
          <div className="relative flex flex-col items-center text-center gap-6">
            <div
              className="leading-none text-fuji-black text-[99px] font-bold"
              aria-label={title}
            >
              {title}
            </div>

            <h1 className="font-gilroy text-title-2 text-fuji-black">
              {subtitle}
            </h1>

            <div className="pt-2">
              <Button as="link" href={`/${lang}`}>
                {homeLabel}
              </Button>
            </div>
          </div>
        </div>
      </Wrapper>
    </Section>
  );
}
